module.exports = __webpack_public_path__ + "static/media/strip-tablet-palm.98ae26b1.png";